import { ModalSlideshow, Tag } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
}

export const PayableRulesTourModal = ({ isOpen, closeModal }: Props) => {
  const { t, activeLanguage } = useTranslation('global');

  const step1Asset = `/static/img/payable-rules/tour/${activeLanguage}/step1.mp4`;
  const step2Asset = `/static/img/payable-rules/tour/${activeLanguage}/step2.mp4`;

  return (
    <ModalSlideshow
      slides={[
        {
          // @ts-expect-error Grapes hacking time
          title: (
            <div>
              <Tag variant="pink">
                {t('bookkeep.integrations.settings.payableRules.tour.tag')}
              </Tag>

              <p className="mt-24" role="heading" aria-level={2}>
                {t(
                  'bookkeep.integrations.settings.payableRules.tour.step1.title',
                )}
              </p>
            </div>
          ),
          content: (
            <p role="contentinfo">
              {t(
                'bookkeep.integrations.settings.payableRules.tour.step1.subtitle',
              )}
            </p>
          ),
          illustration: (
            <video
              loop
              muted
              autoPlay
              title="Payable rules tour step 1"
              className="m-0 h-auto w-full object-cover p-0"
            >
              <source src={step1Asset} type="video/mp4" />
            </video>
          ),
        },
        {
          // @ts-expect-error Grapes hacking time
          title: (
            <div>
              <Tag variant="pink">
                {t('bookkeep.integrations.settings.payableRules.tour.tag')}
              </Tag>

              <p className="mt-24" role="heading" aria-level={2}>
                {t(
                  'bookkeep.integrations.settings.payableRules.tour.step2.title',
                )}
              </p>
            </div>
          ),
          content: (
            <div role="contentinfo">
              <ul className="ml-16 list-disc">
                <li className="mb-16">
                  <span className="font-semibold text-content-primary">
                    {t(
                      'bookkeep.integrations.settings.payableRules.tour.step2.content.conditions',
                    )}
                  </span>
                  <div className="text-content-secondary-bg-primary">
                    {t(
                      'bookkeep.integrations.settings.payableRules.tour.step2.content.conditionsDescription',
                    )}
                  </div>
                </li>
                <li>
                  <span className="font-semibold text-content-primary">
                    {t(
                      'bookkeep.integrations.settings.payableRules.tour.step2.content.outputs',
                    )}
                  </span>
                  <div className="text-content-secondary-bg-primary">
                    {t(
                      'bookkeep.integrations.settings.payableRules.tour.step2.content.outputsDescription',
                    )}
                  </div>
                </li>
              </ul>
            </div>
          ),
          illustration: (
            <video
              loop
              muted
              autoPlay
              title="Payable rules tour step 2"
              className="m-0 h-auto w-full object-cover p-0"
            >
              <source src={step2Asset} type="video/mp4" />
            </video>
          ),
        },
        {
          // @ts-expect-error Grapes hacking time
          title: (
            <div>
              <Tag variant="pink">
                {t('bookkeep.integrations.settings.payableRules.tour.tag')}
              </Tag>

              <p className="mt-24" role="heading" aria-level={2}>
                {t(
                  'bookkeep.integrations.settings.payableRules.tour.step3.title',
                )}
              </p>
            </div>
          ),
          content: (
            <p role="contentinfo">
              {t(
                'bookkeep.integrations.settings.payableRules.tour.step3.subtitle',
              )}
            </p>
          ),
          illustration: (
            // Grapes hacking time. TODO: Move background color to the value from enum.
            <div className="flex flex-1 flex-col items-center justify-center gap-16 self-stretch bg-[#DAE0FF]">
              {[
                t(
                  'bookkeep.integrations.settings.payableRules.tour.step3.content.rule1',
                ),
                t(
                  'bookkeep.integrations.settings.payableRules.tour.step3.content.rule2',
                ),
                t(
                  'bookkeep.integrations.settings.payableRules.tour.step3.content.rule3',
                ),
                t(
                  'bookkeep.integrations.settings.payableRules.tour.step3.content.rule4',
                ),
                t(
                  'bookkeep.integrations.settings.payableRules.tour.step3.content.rule5',
                ),
              ].map((text) => (
                <div
                  key={text}
                  className="text-content-complementary-bg-primary flex h-[32px] w-auto items-center justify-center gap-8 rounded-full bg-background-primary-default p-16 body-m"
                >
                  {text}
                </div>
              ))}
            </div>
          ),
        },
      ]}
      translations={{
        cancel: t('bookkeep.integrations.settings.payableRules.tour.cancel'),
        previous: t(
          'bookkeep.integrations.settings.payableRules.tour.previous',
        ),
        next: t('bookkeep.integrations.settings.payableRules.tour.next'),
        done: t('bookkeep.integrations.settings.payableRules.tour.done'),
      }}
      noAnimation
      isOpen={isOpen}
      onCancel={closeModal}
      onClose={closeModal}
      onDone={closeModal}
    />
  );
};
